import { render, staticRenderFns } from "./myPortfolio.vue?vue&type=template&id=79bcae5a&scoped=true&"
import script from "./myPortfolio.vue?vue&type=script&lang=js&"
export * from "./myPortfolio.vue?vue&type=script&lang=js&"
import style0 from "./myPortfolio.vue?vue&type=style&index=0&id=79bcae5a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79bcae5a",
  null
  
)

export default component.exports